<template>
    <div class="global-dashboard-settings" style="flex: 0 0 0">
        <md-dialog :md-active.sync="open" v-on:close="$router.go(-1)" v-on:md-clicked-outside="$router.go(-1)">
            <md-dialog-title>Global Dashboards</md-dialog-title>
            <div class="horizontal-wrapper" style="margin: 5pt; min-width: 600pt;">
            
                <div style="flex: 4 0 0" class="vertical-wrapper">

                    <md-tabs :md-active-tab="activeTab" :md-dynamic-height="false" v-on:md-changed="(e) => activeTab = e">
                        
                        <md-tab :id="0" md-label="Allgemein">
                            <md-field>
                                <label for="">Name</label>
                                <md-input v-model="name"></md-input>
                            </md-field>
                            <label for="">Dashboard Typ</label>
                            <div>

                                <md-radio v-model="dashboardType" value="table" class="md-primary">Tabelle</md-radio>
                                <md-radio v-model="dashboardType" value="charts" class="md-primary">Charts</md-radio>
                                <md-radio v-model="dashboardType" value="iframe" class="md-primary">Iframe</md-radio>
                            </div>

                            <div class="horizontal-wrapper">
                                <div></div>
                                <md-button class="md-raised md-accent" v-on:click="deleteGlobalDashboard">Löschen</md-button>
                                <div></div>

                            </div>
                        </md-tab>


                        <md-tab :id="1" md-label="Mit Benutzer teilen">
                            <div class="horizontal-wrapper" style="flex: 0 0 auto">
                                <md-field>
                                    <label for="">Suchen</label>
                                    <md-input v-model="searchText"></md-input>
                                </md-field>
                            </div>

                            <div style="flex: 1 0 0; overflow-y: scroll; max-height: 300pt" class="vertical-wrapper">
                                <div v-for="u in users.filter(e => e.name.toLowerCase().includes( searchText.toLowerCase() )) "  :key="u.key" class="horizontal-wrapper" style="flex: 0 0 auto; margin: 2px;">
                                    <input  type="checkbox" style="display: block; -webkit-appearance: auto;" v-model="u.active" :name="u.name" v-on:input="changeUserActive(u.id)">
                                    <label v-on:click="changeUserActive(u.id)">{{ u.name }}</label>
                                </div>
                            </div>
                        </md-tab>

                        <md-tab :id="2" md-label="Mit Gruppe teilen" >
                            <div :id="2" class="horizontal-wrapper" style="margin: 2pt;flex: 0 0 auto">
                                <md-field>
                                    <label for="">Suchen</label>
                                    <md-input v-model="searchTextGroups"></md-input>
                                </md-field>
                            </div>

                            <div style="flex: 1 0 0; overflow-y: scroll; max-height: 300pt" class="vertical-wrapper">
                                <div v-for="g in groups.filter(e => e.name.toLowerCase().includes( searchTextGroups.toLowerCase() )) "  :key="g.key" class="horizontal-wrapper" style="flex: 0 0 auto; margin: 2px;">
                                    <input  type="checkbox" style="display: block; -webkit-appearance: auto;" v-model="g.active" :name="g.name">
                                    <label v-on:click="g.active = !g.active">{{ g.name }}</label>
                                </div>
                            </div>
                        </md-tab>

                    </md-tabs>
                    
                </div>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary" v-on:click="$router.go(-1)">Schließen</md-button>
                <md-button class="md-primary" v-if="activeTab != 2" v-on:click="activeTab = activeTab + 1">Weiter</md-button>

                <md-button class="md-primary" v-if="activeTab == 2" v-on:click="saveGlobalDashbordSettings">Speichern</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>
<script>
export default {
    name: 'global-dashboard-settings-view',
    props: {id: [String, Number]},
    computed:{
        token() {
            return this.$store.getters.token
        },
        globalDashboards(){
            return this.$store.getters.getGlobalDashboards
        }
    },
    watch:{
       
    },
    methods:{
       
        /**
         * DELETE /global-dashboard/:id/details
         */
        async deleteGlobalDashboard(){
            const { isConfirmed } = await this.$swal.fire({ 
                icon: 'warning', 
                title: 'Sicher?',
                text: 'Dashboard wirklich unwiderruflich entfernen?', 
                showConfirmButton: true,
                confirmButtonText: 'Ja',

                showDenyButton: true,
                denyButtonText: 'Nein'
            
            })
            if(isConfirmed){
                this.deleteGlobalDashboardSettings(parseInt(this.id))
            }

        },
        changeUserActive(){
            this.changesMade = true;
        },
        async saveGlobalDashbordSettings(){

            // request post global dashboard
            const id = await this.postGlobalDashboardSettings(this.id)
            await this.postGlobalDashboardSettingsGroups(parseInt(id))

            // reload the global dashboards
            await this.$store.dispatch('globalView/get-global-dashboards')

            this.$router.push({ name: 'main-global-dashboard', params: {id }})
        },
        async getGlobalDashboardSetting(id){

            const url = `${this.$hostname}/api/global-dashboard/${id}/settings`
            const result = await fetch(url,
                { headers: { authorization: this.token, "Content-Type": "application/json", }})
            

            if(result.status != 200){
                return
            }

            const {globalDashboard, users} = await result.json()
            if((!globalDashboard) && !users.length){
                this.$swal.fire({ icon : 'error', text: 'Dieses Dashboard gehört jemanden anderes', title: 'No Ownership'})
                return
            }
            if(globalDashboard){

                this.name = globalDashboard.name;
                this.dashboardType = globalDashboard.type;
            }

            users.forEach(e => e.key = this.$uuid.v4());
            this.users = [...users];
        },

        async postGlobalDashboardSettings(id){
            
            // build post package
            const globalDashboard = { id, name: this.name, type: this.dashboardType }
            const users = this.users;

            const body = JSON.stringify({globalDashboard, users})


            const url = `${this.$hostname}/api/global-dashboard/${id}/settings`
            const result = await fetch(url,{   
                method: 'POST',
                headers: { authorization: this.token, "Content-Type": "application/json", },
                body
            })
            

            if(result.status != 200){
                return -1
            }

            const globalDBId = (await result.json()).id

            

            return globalDBId

        },


        async getGlobalDashboardSettingsGroups(id){

            const url = `${this.$hostname}/api/global-dashboard/${id}/settings/groups`
            const result = await fetch(url,
                { headers: { authorization: this.token, "Content-Type": "application/json", }})
            

            if(result.status != 200){
                return
            }

            const groups = await result.json()
            groups.forEach(e => e.key = this.$uuid.v4());
            this.groups = [...groups];
        }, 
        async postGlobalDashboardSettingsGroups(id){

            const url = `${this.$hostname}/api/global-dashboard/${id}/settings/groups`
            const result = await fetch(url,{
                method: 'POST', 
                headers: { authorization: this.token, "Content-Type": "application/json", },
                body: JSON.stringify({ groups: this.groups })
            })


            if(result.status != 200){
                return
            }
            return
          
        },

        async deleteGlobalDashboardSettings(id){
            try{
                const url = `${this.$hostname}/api/global-dashboard/${id}/settings`
                const response = await fetch(url, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `${this.token}`, // Include the token in the Authorization header
                    },
                    body: JSON.stringify({IDh_global_db: id}), // Include the userId in the request body
                });
                
                if(response.ok){
                    // reload all global dashboards
                    await this.$store.dispatch('globalView/get-global-dashboards')
                    this.$router.push({ name: 'main-global-view' })

                    
                }else{
                    console.error(`DELETE ${this.$hostname}/global-dashboard/${id}/settings`)
                }


            }catch(e){
                console.log(e);
            }
        }

    },
    beforeRouteEnter(from, to, next){
        next(vm => {
            vm.open = true

           
            const IDh_global_db = parseInt(to.params.id | vm.id)


            // 
            vm.getGlobalDashboardSetting(IDh_global_db)
            vm.getGlobalDashboardSettingsGroups(IDh_global_db)
        })  
    },
    sockets:{
      
      'set-global-dashboard-settings-details-error': function(error){
        if(error == 'no-ownership'){
            this.$swal.fire({ icon : 'error', text: 'Dieses Dashboard gehört jemanden anderes', title: 'No Ownership'})
            //this.activeGlobalDashboard = this.lastDashboardId
        }
      }
    },
    data(){
        return{
            open: false,
            activeGlobalDashboard: -1,
            lastDashboardId: -1,

            name : '',
            users: [],
            searchText: '',
            dashboardType: 'table',

            changesMade: false,


            searchTextGroups: '',
            groups: [],
            activeTab: 0
        }
    }
}
</script>
<style>
.md-tabs.vertical-wrapper .md-tabs-navigation{
    flex: 0 0 auto;
}
.md-tabs.vertical-wrapper .md-content{
    display: flex;
    flex-direction: column;
}
.global-dashboard-settings .md-tab{
    display: flex;
    flex-direction: column;
    flex: 1 0 0;
    height: 100%;
}
.gd-item{
    background-color: var(--color1);
    padding: 5pt 20pt;
    cursor: pointer;
}
.gd-item.active{
    background-color: var(--color2);
    color: var(--color1);
}
</style>